import type * as React from "react"

type AppContentProps = {
  variant?: "header" | "sidebar"
} & React.ComponentProps<"main">

export function AppContent({ variant = "header", children, className, ...props }: AppContentProps) {
  if (variant === "sidebar") {
    return (
      <main
        className={`flex flex-1 flex-col bg-white dark:bg-gray-950 ${className ?? ""}`}
        {...props}
      >
        {children}
      </main>
    )
  }

  return (
    <main
      className="mx-auto flex h-full w-full max-w-7xl flex-1 flex-col gap-4 rounded-xl"
      {...props}
    >
      {children}
    </main>
  )
}
